import {
  PAGE_LOADING,
  PAGE_LOADED,
  ANALYTICS_POPULATE,
  SELECT_LOCATIONS,
  SELECT_DATES,
  GET_TRENDING_DATA,
  GET_METRIC_LIST,
  UPDATE_TOP_ITEMS,
  UPDATE_LOWEST_ITEMS
} from "../../constants/types";
import axios from "axios";
import { toggleLowItem, toggleTopItem } from "../salesLoader";
import { requestInventoryData } from "../inventory/InventoryActions";
import { requestProductAnalyticsData } from "../productAnalytics/ProductAnalyticsActions";

export const loadExtraData = (start_date, end_date, itemType) => {
  return (dispatch, getState) => {
    if (itemType === "top_items_by_sales") {
      dispatch(toggleTopItem(true));
    } else if (itemType === "lowest_items_by_sales") {
      dispatch(toggleLowItem(true));
    }
    return new Promise((resolve, reject) => {
      const locations = getState().selectedLocations;
      console.log('locationnn', locations);
      axios
        .get("api/analytics/", {
          params: {
            locations,
            start_date: start_date,
            end_date: end_date,
            get_all_values: itemType,
            type: "oscar_dashboard"
          }
        })
        .then(response => {
          console.log("loadExtraData res", response);
          if (response.status === 200) {
            if (itemType === "top_items_by_sales") {
              dispatch({
                type: UPDATE_TOP_ITEMS,
                top_items_by_sales: response.data
              });
              setTimeout(()=>{
                dispatch(toggleTopItem(false));
              },1000)
            } else if (itemType === "lowest_items_by_sales") {
              dispatch({
                type: UPDATE_LOWEST_ITEMS,
                lowest_items_by_sales: response.data
              });
              setTimeout(()=>{
                dispatch(toggleLowItem(false));
              },1000)
            }
          }
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  };
};
export const loadInitialAnalyticsState = (start_date, end_date) => {
  console.log('loadInitialAnalyticsStateloadInitialAnalyticsState')
  return (dispatch,getState) => {
    dispatch({
      type: PAGE_LOADING
    });
    dispatch(requestInventoryData())    
    dispatch(requestProductAnalyticsData()) 
    const locations = getState().selectedLocations;   
    axios
      .get("api/analytics/", {
        params: {
          locations,
          start_date: start_date,
          end_date: end_date,
          type: "oscar_dashboard"
        }
      })
      .then(response => {
        dispatch({
          type: ANALYTICS_POPULATE,
          payload: response.data
        });

        Promise.all([
          dispatch(loadExtraData(start_date, end_date, "top_items_by_sales")),
          dispatch(loadExtraData(start_date, end_date, "lowest_items_by_sales"))
        ]).then(res => {
          dispatch({
            type: PAGE_LOADED
          });
        });
      });
  };
};

const requestAnalyticsData = (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    const { filters } = getState().analytics;
    const { auth } = getState();
    const locations = getState().selectedLocations;
    if(auth.filters){
      if(auth.filters.has_inventory){
        dispatch(requestInventoryData())    
      }
      if(auth.filters.has_product_analytics){
       dispatch(requestProductAnalyticsData())  
      }  

    }
    axios
      .get("api/analytics/", {
        params: {
          locations,
          start_date: filters.selectedDate.start_date,
          end_date: filters.selectedDate.end_date,
          type: "oscar_dashboard"
        }
      })
      .then(response => {
        dispatch({
          type: ANALYTICS_POPULATE,
          payload: response.data
        });
        Promise.all([
          dispatch(
            loadExtraData(
              filters.selectedDate.start_date,
              filters.selectedDate.end_date,
              "top_items_by_sales"
            )
          ),
          dispatch(
            loadExtraData(
              filters.selectedDate.start_date,
              filters.selectedDate.end_date,
              "lowest_items_by_sales"
            )
          )
        ]).then(res => {
          dispatch({
            type: PAGE_LOADED
          });
        });
      });
  });
};

// export const selectLocations = selectedLocations => {
//   return (dispatch, getState) => {
//     dispatch({
//       type: SELECT_LOCATIONS,
//       payload: selectedLocations
//     });
//     requestAnalyticsData(dispatch, getState);
//   };
// };

export const selectLocations = selectedLocations => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: SELECT_LOCATIONS,
        payload: selectedLocations
      });
      const { filters } = getState().analytics;
      const locations = getState().selectedLocations;
      // axios
      //   .get("api/analytics/", {
      //     params: {
      //       locations,
      //       start_date: filters.selectedDate.start_date,
      //       end_date: filters.selectedDate.end_date,
      //       type: "oscar_dashboard"
      //     }
      //   })
      //   .then(response => {
      //     dispatch({
      //       type: ANALYTICS_POPULATE,
      //       payload: response.data
      //     });
      //     resolve(response);
      //   });
      requestAnalyticsData(dispatch, getState);
    });
  };
};

export const selectDate = selectedDate => {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_DATES,
      payload: selectedDate
    });
    requestAnalyticsData(dispatch, getState);
  };
};

export const getSalesTrend = values => {
  console.log("getSalesTrend", values);
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axios
        .get("api/analytics/metrics/", {
          params: {
            metrics: values.metrics,
            start_date: values.start_date,
            end_date: values.end_date,
            type: "oscar_dashboard"
          }
        })
        .then(response => {
          console.log(response, "response");
          resolve(response);
          dispatch({
            type: GET_TRENDING_DATA,
            payload: response.data
          });
        })
        .catch(err => {
          reject(err);
          console.log(err);
        });
    });
  };
};

export const getMetricList = () => {
  console.log("call action getMetricList");
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axios
        .get("api/analytics/metrics/list/")
        .then(response => {
          console.log(response, "response metric list");
          resolve(response);
          dispatch({
            type: GET_METRIC_LIST,
            payload: response.data
          });
        })
        .catch(err => {
          reject(err);
          console.log(err);
        });
    });
  };
};
getMetricList;



// WEBPACK FOOTER //
// ./src/modules/analytics/AnalyticsActions.js